<app-playlist-files *ngIf="stream && playlist" [stream]="stream" [playlist]="playlist" [isModal]="false"></app-playlist-files>
<div *ngIf="!stream || !playlist" class="loader">
  <mat-spinner [diameter]="25"></mat-spinner>
</div>

